import { ProgramContainer } from "src/entities/formTemplateDataType";

export type ServiceAction = 'new' | 'renewal' | 'update' | 'withdrawal' | 'payment';

export interface TaskCompletionParams {
  serviceName: string;
  serviceItems: string;
  serviceAction: ServiceAction;
  value: string;
  submissionId: string;
}

const TrackTaskCompletion = (
  programContainer: ProgramContainer,
  params: TaskCompletionParams
) => {
  if (sessionStorage.getItem("gaUploadPause") === "true") {
    console.log('[TrackTaskCompletion] Skipping - gaUploadPause is true');
    return;
  }

  if (programContainer?.sendPageDataToGA === false) {
    console.log('[TrackTaskCompletion] Skipping - sendPageDataToGA is disabled');
    return;
  }

  const { serviceName, serviceItems, serviceAction, value, submissionId } = params;

  if (!serviceName || !serviceItems || !serviceAction || !submissionId) {
    console.warn('[TrackTaskCompletion] Missing required parameters, skipping event.');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'service_complete',
    'service_name': serviceName.toLowerCase(),
    'service_items': serviceItems.toLowerCase(),
    'service_action': serviceAction.toLowerCase(),
    'value': value ?? '0.00',
    'submission_id': submissionId,
  });
};


/**
 * Returns a unique, randomly generated submission ID for a given service key,
 * persisted in sessionStorage so it stays consistent across page refreshes
 * within the same session. The ID contains no user-identifiable information.
 */
export const getSubmissionId = (serviceKey: string): string => {
    const storageKey = `gtm_sid_${serviceKey}`;
    try {
        const storedId = sessionStorage.getItem(storageKey);
        if (storedId) {
            return storedId;
        }
        const randomSegment = () => Math.random().toString(36).substring(2);
        const submissionId = `${randomSegment()}${randomSegment()}`.substring(0, 16);
        sessionStorage.setItem(storageKey, submissionId);
        return submissionId;
    } catch {
        const randomSegment = () => Math.random().toString(36).substring(2);
        return `${randomSegment()}${randomSegment()}`.substring(0, 16);
    }
};
export default TrackTaskCompletion;
